import { SlackWorkspaceRef } from "../SlackService";

/**
 * Query key factory for the Slack domain. Every key hangs off `all(orgId)` for two reasons:
 * the org is the root the domain-wide `all(orgId)` invalidation contract hangs on, and every
 * response is authorization-scoped — one org's 404 must not be served from a key another org
 * can hit.
 */
export const slackQueryKeys = {
  all: (orgId: string) => ["slack", orgId] as const,
  connections: (orgId: string) =>
    [...slackQueryKeys.all(orgId), "connections"] as const,
  outboundChannels: (orgId: string) =>
    [...slackQueryKeys.all(orgId), "outboundChannels"] as const,
  workspaceChannels: (orgId: string, workspace: SlackWorkspaceRef) =>
    [
      ...slackQueryKeys.all(orgId),
      "workspaceChannels",
      workspace.enterpriseId,
      workspace.teamId,
    ] as const,
};
